import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

const schema = z.object({
  name: z.string(),
  description: z.string().optional(),
})

export type EditAudioFormValues = z.infer<typeof schema>

export const editAudioFormResolver = zodResolver(schema)

export const EDIT_AUDIO_FORM_ID = 'edit-audio-form'
